<template>
	<div>
		<v-container>
            <v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

            <v-card :loading="isEdit && loading" :disabled="isEdit && loading">
				<v-card-title>
					<template v-if="isEdit">
						تعديل على شركة
					</template>
					<template v-else>
						إضافة شركة جديدة
					</template>
				</v-card-title>

                <v-card-text>
					<v-form v-model="valid">
						<v-row justify="center" class="py-1">
							<v-col cols="12" md="6">
								<v-row>
									<v-col cols="12" class="py-1">
										<v-text-field v-model="newCompany.name" label="اسم الشركة" outlined hide-details="auto" :rules="[rules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" class="py-1">
										<v-autocomplete
											v-model="newCompany.rankID"
											:items="ranks"
											outlined
											hide-details="auto"
											label="رتبة الشركة"
											item-text="name"
											item-value="adRankID"
											:rules="[rules.required]"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" class="py-1">
										<v-text-field v-model="newCompany.webLink" label="رابط موقع الشركة" outlined hide-details="auto" :rules="[rules.optionalLink]" dir="ltr"></v-text-field>
									</v-col>
									<v-col cols="12" class="py-1">
										<v-textarea v-model="newCompany.description" label="الوصف" outlined hide-details="auto"></v-textarea>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" md="6">
								<v-row>
									<v-col cols="12" class="pa-2 text-center">
										<v-avatar
											v-if="!isEdit"
											color="grey lighten-5"
											height="200"
											tile
											width="200"
											class="mt-1"
										>
											<v-img
												contain
												style="border: 1px dotted grey"
												:src="newCompany.attachment | imgToURL"
												aspect-ratio="1"
											>
											</v-img>
										</v-avatar>

										<v-avatar
											v-if="isEdit"
											color="grey lighten-5"
											height="200"
											tile
											width="200"
											class="mt-1"
										>
											<v-img
												contain
												style="border: 1px dotted grey"
												:src="oldAttachment"
												aspect-ratio="1"
											>
												<v-chip style="opacity: 0.5;" :href="oldAttachment" target="_blank">
													الصورة السابقة
													<v-icon right>mdi-file-eye</v-icon>
												</v-chip>
												<v-spacer></v-spacer>
												<v-btn icon @click="showUpdateLogo = true">
													<v-icon>mdi-pen</v-icon>
												</v-btn>
											</v-img>
										</v-avatar>
									</v-col>
									<v-col v-if="!isEdit" cols="12" class="pa-2" style="padding-top: 23px !important;">
										<v-file-input
											v-model="newCompany.attachment"
											:rules="isEdit ? [rules.max2mb, rules.optionalImage] : [rules.required, rules.max2mb, rules.optionalImage]"
											accept="image/*"
											show-size
											prepend-inner-icon="mdi-camera"
											prepend-icon
											label="صورة الشركة"
											outlined
											hide-details="auto"
										></v-file-input>
									</v-col>
								</v-row>
							</v-col>
						</v-row>

						<v-row justify="center" class="py-1">
							<v-col cols="12" class="text-center">
								<v-btn class="primary" :disabled="!valid" :loading="loading" @click="addnewCompany">
									<template v-if="isEdit">
										حفظ
									</template>
									<template v-else>
										إضافة
									</template>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
                </v-card-text>
            </v-card>
		</v-container>

		<v-dialog v-model="showUpdateLogo" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث صورة الشركة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row dense>
							<v-col cols="12">
								<v-img
									contain
									style="border: 1px dotted grey"
									:src="newCompany.attachment | imgToURL"
									aspect-ratio="1"
									max-height="200"
								>
								</v-img>
							</v-col>
							<v-col cols="12">
								<v-file-input
									v-model="newCompany.attachment"
									:rules="[rules.required, rules.max2mb]"
									accept="image/*"
									show-size
									prepend-inner-icon="mdi-camera"
									prepend-icon
									label="صورة الشركة"
									outlined
									hide-details="auto"
								></v-file-input>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="updateLogo">تحديث</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الشركات', exact: true, to: { name: "dashboard-companies" }},
				{ text: 'إضافة شركة', disabled: true }
			],
			newCompany: {},
			valid: false,
			valid1: false,
			loading: false,
			ranks: [],

			isEdit: false,
			recordID: null,
			oldAttachment: null,
			showUpdateLogo: false
		};
	},
	mounted(){
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.loading = true;
			this.recordID = this.$route.params.recordID;
			this.breadcrumbs[2].text = "التعديل";
			this.getRecord();
		} else {
			console.log("not edit");
		}

		this.getRanks();
	},
	methods:{
		getRecord(){
			client
				.get("/api/companies/get/" +this.recordID)
				.then(response => {
					console.log(response);
					this.newCompany = response.data.data;
					this.newCompany.logoPath = addBaseURL(this.newCompany.logoPath);
					this.oldAttachment = response.data.data.logoPath;
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRanks() {
			client
				.get("/api/unspokenname/adranks")
				.then(response => {
					this.ranks = response.data.sort(
						(a, b) => a.priority - b.priority
					);

					// this.totalTop = this.ranks
					// 	.map(r => r.topPriority)
					// 	.reduce((a, b) => a + b, 0);
					// this.totalRight = this.ranks
					// 	.map(r => r.rightPriority)
					// 	.reduce((a, b) => a + b, 0);

					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addnewCompany() {
			if(this.isEdit){
				this.updateCompany();
			} else {
				this.insertCompany();
			}
		},
		insertCompany(){
			this.loading = true;
			var data = new FormData();
			data.append("name", this.newCompany.name);
			data.append("rankID", this.newCompany.rankID);
			
			if (this.newCompany.webLink) {
				data.append("webLink", this.newCompany.webLink);
			}

			if (this.newCompany.description) {
				data.append("description", this.newCompany.description);
			}
			
			if (this.newCompany.attachment) {
				data.append("attachment", this.newCompany.attachment);
			}

			clientNotifier
				.post("/api/companies/new", data)
				.then(() => {
					this.$router.push({ name: "dashboard-companies-manage" });
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateCompany(){
			this.loading = true;
			var data = new FormData();
			data.append("companyID", this.newCompany.id);
			data.append("name", this.newCompany.name);
			data.append("rankID", this.newCompany.rankID);
			
			if (this.newCompany.webLink) {
				data.append("webLink", this.newCompany.webLink);
			}

			if (this.newCompany.description) {
				data.append("description", this.newCompany.description);
			}

			clientNotifier
				.post("/api/companies/update", data)
				.then(() => {
					this.$router.push({ name: "dashboard-companies-manage" });
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateLogo(){
			this.loading = true;
			var data = new FormData();
			data.append("companyID", this.newCompany.id);
			data.append("attachment", this.newCompany.attachment);

			clientNotifier
				.post("/api/companies/updateLogo", data)
				.then((response) => {
					this.newCompany.logoPath = addBaseURL(response.data.data.logoPath);
					this.oldAttachment = this.newCompany.logoPath;
					this.showUpdateLogo = false;
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>